import styled from 'styled-components';
import { StyledCheck } from '../../../app/components/checkbox/StyledCheckbox';
import { MarketplaceStyled } from '../../marketplace/assets/marketplaceStyle';
import { SellingItemStyle } from '../../marketplaceActivity/assets/sellingItemStyle';
import { ShopStyled } from '../../shopSetting/assets/shopStyled';

export const HeaderFilter = styled.div`
  .row {
    &.browse-filter {
      gap: 13px;
      margin: 0;
      @media screen and (max-width: 767px) {
        gap: 8px;
      }
      .col-md-4 {
        width: 273px;

        @media screen and (max-width: 767px) {
          flex-grow: 1;
          width: auto;
        }
      }
      .col-md-3 {
        width: 153px;
        .menu-toggle {
          padding: 0;
          svg {
            width: 20px;
            height: 20px;
          }
        }
      }
      .col-md-2 {
        width: 96px;
      }
      .reset-filter-btn {
        @media screen and (max-width: 767px) {
          width: auto;
        }

        .filter-icon-button {
          @media screen and (max-width: 767px) {
            padding: 6px 8px;
            svg {
              width: 14px;
              height: 14px;
            }
          }
        }
      }
    }
  }
  .row {
    &.scavenger-hunt-filter {
      gap: 13px;
      margin: 0;
      @media screen and (max-width: 767px) {
        gap: 8px;
      }
      .col-md-4 {
        width: 273px;
        @media screen and (max-width: 930px) {
          width: 218px;
        }
        @media screen and (max-width: 767px) {
          width: auto;
          flex-grow: 1;
        }
      }
      .col-md-3 {
        width: 153px;
        @media screen and (max-width: 930px) {
          width: 100px;
        }
        @media screen and (max-width: 767px) {
          display: none;
        }
      }
      .col-md-2 {
        width: 96px;
        @media screen and (max-width: 767px) {
          width: auto;
        }
        .filter-icon-button {
          @media screen and (max-width: 767px) {
            padding: 6px 8px;
            svg {
              width: 14px;
              height: 14px;
            }
          }
        }
      }
    }
  }

  .row {
    margin: 0 -5px;
    [class*='col-'] {
      padding: 0 5px;
    }
    [class*='col'] {
      padding: 0 5px;
    }
    .col-md-4 {
      width: 283px;
    }
    .col-md-3 {
      width: 163px;
    }
    .col-md-2 {
      width: 106px;
      button {
        font-weight: 400;
      }
    }
    .menu-toggle {
      padding: 7px 8px;
      height: 30px;
      svg {
        width: 16px;
        height: 16px;
      }
    }
  }
`;
export const Title = styled(SellingItemStyle.Title)`
  margin-bottom: 14px;
`;
export const Category = styled(MarketplaceStyled.Category)`
  padding: 4px 8px;
  margin-bottom: 16px;
`;
export const RequestReviews = styled.div`
  display: flex;
  align-items: center;
  margin-right: 27px;
  svg {
    color: ${({ theme }) => theme.yellow};
    margin-right: 10px;
  }
  p {
    font-size: 14px;
    line-height: 21px;
    font-weight: 600;
    margin-bottom: 0 !important;
  }
`;
export const FormLabel = styled(ShopStyled.FormLabel)`
  margin-bottom: 8px;
`;
export const DividerLabel = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  margin: 32px 0;
  &:before {
    position: absolute;
    content: "''";
    left: 0;
    right: 0;
    top: 50%;
    font-size: 1px;
    transform: translateY(-50%);
    background: url(${window.origin + '/divider.svg'});
    background-repeat: repeat-x;
    z-index: -1;
  }
  span {
    height: 40px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.badgeText};
    background-color: ${({ theme }) => theme.badgeBgLight};
    border-radius: 100%;
    text-transform: uppercase;
    box-shadow: 0 0 0 18px ${({ theme }) => theme.white};
  }
`;
export const PaymentOptions = styled.div`
  label {
    color: ${({ theme }) => theme.primaryDark};
    margin-bottom: 14px !important;
    & > span {
      margin-left: 12px !important;
    }
    ${StyledCheck} {
      margin-left: 32px !important;
    }
  }
`;

export const DropdownPlaceHolder = styled.h6`
  color: ${({ theme }) => theme.placeholderColor} !important;
`;

export const ScavengerStyled = {
  HeaderFilter,
  Title,
  Category,
  RequestReviews,
  FormLabel,
  DividerLabel,
  PaymentOptions,
  DropdownPlaceHolder,
};
